import { KeyWrapper } from './KeyWrapper';
import { Keyboard, KeyboardProps } from './Keyboard';

export function KeyboardWrapper(props: Omit<KeyboardProps, 'keyComponent'>) {
  return <Keyboard {...props} keyComponent={KeyWrapper} />;
}
